$(document).on('click', '.mrk-addon-dropdown-item', function () {
    $(this)
    .closest('.mrk-frame-cart-addon-inner')
    .find('.mrk-cart-frame-add')
    .trigger('click');
});

 
(function () {
  function syncUpsellToProgressBar() {
    requestAnimationFrame(() => {
      const upsellSource = document.querySelector('.mrk-upsell-wrapper');
      const progressBarTarget = document.querySelector('.wd-collection-progress-bar');
 
      if (!upsellSource) return; // upsell block not present on this page
      if (!progressBarTarget) return; // progress bar not present
 
      // Replace the inner content of the progress bar with the upsell HTML
      progressBarTarget.innerHTML = upsellSource.innerHTML;
    });
  }
 
  // Fires in the `finally` block of updateQuantity — always runs after fetch
  document.addEventListener('cart:updated', syncUpsellToProgressBar);
 
  // Also run once on page load so the initial state is in sync
  document.addEventListener('DOMContentLoaded', syncUpsellToProgressBar);
})();
 

// document.addEventListener('DOMContentLoaded', function () {
//   const isTouchDevice = () => window.matchMedia('(hover: none) and (pointer: coarse)').matches;

//   function initPopup(wrapperSelector, iconSelector, popupSelector) {
//     document.querySelectorAll(wrapperSelector).forEach(function (wrapper) {
//       const icon = wrapper.querySelector(iconSelector);
//       const popup = wrapper.querySelector(popupSelector);

//       if (!icon || !popup) return;

//       if (!isTouchDevice()) {
//         let hideTimeout;

//         function showPopup() {
//           clearTimeout(hideTimeout);
//           popup.style.display = 'block';
//           popup.style.opacity = '1';
//           popup.style.visibility = 'visible';
//         }

//         function hidePopup() {
//           hideTimeout = setTimeout(function () {
//             popup.style.display = 'none';
//             popup.style.opacity = '0';
//             popup.style.visibility = 'hidden';
//           }, 100);
//         }

//         icon.addEventListener('mouseenter', showPopup);
//         icon.addEventListener('mouseleave', hidePopup);
//         popup.addEventListener('mouseenter', showPopup);
//         popup.addEventListener('mouseleave', hidePopup);

//       } else {
//         icon.addEventListener('click', function (e) {
//           e.stopPropagation();
//           const isVisible = popup.style.display === 'block';

//           // Close all popups first
//           document.querySelectorAll('.wd-subtotal-popup-wrapper, .wd-total-saving-popup-wrapper').forEach(function (p) {
//             p.style.display = 'none';
//             p.style.opacity = '0';
//             p.style.visibility = 'hidden';
//           });

//           if (!isVisible) {
//             popup.style.display = 'block';
//             popup.style.opacity = '1';
//             popup.style.visibility = 'visible';
//           }
//         });
//       }
//     });
//   }

//   // Init both popups
//   initPopup('.wd-cart-subtotal-wrapper', '.mrk-popup-icon', '.wd-subtotal-popup-wrapper');
//   initPopup('.mrk-saving-wrapper', '.mrk-popup-icon', '.wd-total-saving-popup-wrapper');

//   // Close on outside tap (mobile only)
//   document.addEventListener('click', function () {
//     if (!isTouchDevice()) return;
//     document.querySelectorAll('.wd-subtotal-popup-wrapper, .wd-total-saving-popup-wrapper').forEach(function (p) {
//       p.style.display = 'none';
//       p.style.opacity = '0';
//       p.style.visibility = 'hidden';
//     });
//   });
// });


// Shopify Forms app fixes. The full fix set is scoped to the trade-page popup
// form (#wd-trade-request-items); every other Forms embed store-wide gets ONLY
// the dropdown-under-field re-anchor (stock list height, no other changes).
// 1) Floating labels: the app measures label height once on mount; a form that
//    mounts inside a closed <dialog> measures 0 and every label gets an
//    off-center inline `top`. The CSS below re-centers state-independently
//    (textareas use the app's hardcoded 46px reference height, so 23px).
// 2) Select dropdowns: the app opens the option list upward whenever the field
//    sits in the lower half of the form; re-anchor it below the toggle so it
//    behaves like a normal dropdown, and lift the ~160px height cap to ~6 items.
// Depending on the app version/flow, the form renders either inside the open
// shadow root of a <shopify-forms-embed> or directly in the light DOM. Every
// fix is applied both ways: the stylesheet goes into any shadow root AND an
// id-scoped copy into document.head; element tweaks query both trees. The
// section gets data-wd-forms-fix="on" as inspectable proof the patch ran.
(function () {
  var SCOPE_ID = 'wd-trade-request-items';
  // Re-anchor the option list under the field, and unclip the app's own
  // wrappers (its inline embed wrapper and form container both have
  // overflow:hidden, which chops a downward list at the form's bottom edge —
  // the reason the app opens lists upward in the first place).
  var DROPDOWN_RULE =
    "[class*='_showUpwards_']{bottom:auto !important;top:100% !important;margin-bottom:0 !important;margin-top:4px !important;}" +
    "section[class*='_inline_']{overflow:visible !important;}" +
    "section[class*='_inline_'] [class*='_formContainer_']{overflow:visible !important;}";
  var FIX_RULES = [
    "label[id^='label-']{top:50% !important;translate:0 -50%;}",
    "div:has(> textarea) > label[id^='label-']{top:23px !important;}",
    DROPDOWN_RULE,
    "[class*='_dropdownContainer_'],[class*='_optionList_']{max-height:272px !important;}",
    // Project details: static label above the field (styled like the select's
    // "What do you need?" label) with the placeholder inside. Must come after
    // the generic label rules above so its overrides win on equal specificity.
    "div:has(> textarea) > label[for='custom#project_details']{position:static !important;order:-1;top:auto !important;translate:none !important;transform:none !important;font:var(--forms-body-font);line-height:20px;color:var(--body-text-color);padding-bottom:10px;}",
    "textarea[name='custom#project_details']{padding:var(--form-field-padding) !important;}",
    // The app's ::before bar only shields text from the floating label, which
    // no longer sits inside the box — left on, it paints over the new label.
    "div:has(> textarea[name='custom#project_details'])::before{display:none !important;}",
    "textarea::placeholder{color:var(--form-placeholder-color);}"
  ];
  var PROJECT_DETAILS_PLACEHOLDER =
    'Sizes, quantities, budget, deadline, and any pieces you already have in mind.';
  var patchedRoots = new WeakSet();
  var dropdownRoots = new WeakSet();

  function injectCss(root, css) {
    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      root.adoptedStyleSheets.push(sheet);
    } catch (error) {
      var style = document.createElement('style');
      style.textContent = css;
      root.appendChild(style);
    }
  }

  // Placeholder (React leaves unmanaged attributes alone, so it sticks) and
  // error spacing: inline margins beat any stylesheet, and the pull-up is
  // measured from the parent's real computed gap. Re-run by an observer since
  // errors only mount after a failed submit.
  function fixElements(tree) {
    var textarea = tree.querySelector("textarea[name='custom#project_details']");
    if (textarea && !textarea.placeholder) textarea.placeholder = PROJECT_DETAILS_PLACEHOLDER;
    tree.querySelectorAll('output[role="alert"]').forEach(function (err) {
      if (err.dataset.wdSpaced) return;
      err.dataset.wdSpaced = '1';
      var gap = parseFloat(getComputedStyle(err.parentElement).rowGap) || 12;
      err.style.setProperty('margin-top', 3 - gap + 'px', 'important');
      err.style.setProperty('margin-bottom', '12px', 'important');
    });
  }

  function watchTree(tree) {
    if (patchedRoots.has(tree)) return;
    patchedRoots.add(tree);
    fixElements(tree);
    new MutationObserver(function () {
      fixElements(tree);
    }).observe(tree, { childList: true, subtree: true });
  }

  function patchSection(scope) {
    scope.setAttribute('data-wd-forms-fix', 'on');

    // Light-DOM rendering: one id-scoped stylesheet in the document head.
    if (!document.getElementById('wd-forms-fix-style')) {
      var lightStyle = document.createElement('style');
      lightStyle.id = 'wd-forms-fix-style';
      lightStyle.textContent = FIX_RULES.map(function (rule) {
        return '#' + SCOPE_ID + ' ' + rule;
      }).join('');
      document.head.appendChild(lightStyle);
    }
    watchTree(scope);

    // Shadow-root rendering: inject the rules into each embed's root.
    scope.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      var root = embed.shadowRoot;
      if (!root || patchedRoots.has(root)) return;
      injectCss(root, FIX_RULES.join(''));
      watchTree(root);
    });
  }

  // Other forms store-wide: dropdown under the field only. The section raise
  // keeps a downward list from being covered by the next section (sections'
  // content wrappers all sit at z-index 1, so the later sibling wins ties);
  // dialog-hosted embeds are excluded — they render in the top layer, and
  // raising their host section would cover a raised sibling again.
  function patchOtherForm(host) {
    host.setAttribute('data-wd-dropdown-fix', 'on');
    if (!document.getElementById('wd-forms-dropdown-style')) {
      var st = document.createElement('style');
      st.id = 'wd-forms-dropdown-style';
      st.textContent =
        DROPDOWN_RULE +
        "#trade-sign-up-form [class*='_gridItemContent_']{padding-bottom:80px !important;}" +
        '.custom-section-content:has(shopify-forms-embed):not(:has(dialog shopify-forms-embed)){z-index:var(--layer-raised,2);}' +
        '.custom-section-content:has([data-form-root]):not(:has(dialog [data-form-root])){z-index:var(--layer-raised,2);}';
      document.head.appendChild(st);
    }
    var root = host.shadowRoot;
    if (root && !dropdownRoots.has(root)) {
      dropdownRoots.add(root);
      injectCss(root, DROPDOWN_RULE);
    }
  }

  // Trade sign-up form: the form ends flush with its section, leaving no room
  // for the open list, so its content area gets permanent bottom padding from
  // page load. The form hydrates after the page loads (inside the embed's
  // shadow root, or in the light DOM), so observers wait for it to appear,
  // apply the inline padding once, and disconnect.
  (function padTradeForm() {
    var section = document.getElementById('trade-sign-up-form');
    if (!section) return;
    var sectionObs = null;
    var shadowObs = null;
    var tryApply = function () {
      var host = section.querySelector('shopify-forms-embed');
      var roots = [section];
      if (host && host.shadowRoot) roots.push(host.shadowRoot);
      for (var i = 0; i < roots.length; i++) {
        var content = roots[i].querySelector("[class*='_gridItemContent_']");
        if (content) {
          content.style.setProperty('padding-bottom', '80px', 'important');
          if (sectionObs) sectionObs.disconnect();
          if (shadowObs) shadowObs.disconnect();
          return true;
        }
      }
      return false;
    };
    var check = function () {
      if (tryApply()) return;
      var host = section.querySelector('shopify-forms-embed');
      if (host && host.shadowRoot && !shadowObs) {
        shadowObs = new MutationObserver(tryApply);
        shadowObs.observe(host.shadowRoot, { childList: true, subtree: true });
      }
    };
    sectionObs = new MutationObserver(check);
    sectionObs.observe(section, { childList: true, subtree: true });
    check();
  })();

  function onFormsInteraction(event) {
    if (!(event.target instanceof Element)) return;
    var scope = event.target.closest('#' + SCOPE_ID);
    if (scope) {
      patchSection(scope);
      return;
    }
    var host = event.target.closest('shopify-forms-embed, [data-form-root]');
    if (host) patchOtherForm(host);
  }

  document.addEventListener('click', onFormsInteraction);
  document.addEventListener('focusin', onFormsInteraction);
})();